import { render, staticRenderFns } from "./LocationDialog.vue?vue&type=template&id=b2fba4a4"
import script from "./LocationDialog.vue?vue&type=script&lang=js"
export * from "./LocationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports